export const SCROLL_BUTTON_ID = 'scroll-to-top-button-event-logs'
